import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconEmail';
/** Renders an SVG icon. */
const SvgEmail = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 9a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm2 13.436V23a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-.134a1 1 0 0 1-.207-.159l-6.5-6.5a1 1 0 0 1-.207-.3l-1.874 1.427a2 2 0 0 1-2.424 0l-1.874-1.428a1 1 0 0 1-.233.327zm5.366-7.71-.046.041L6 19.707v-9.069zM6.263 8.325 16 15.743l9.737-7.419A1 1 0 0 0 25 8H7a1 1 0 0 0-.737.324ZM26 10.638l-5.366 4.088a1 1 0 0 1 .073.067L26 20.086z"
      />
    </svg>
  );
};
SvgEmail.displayName = displayName;
export default SvgEmail;
